export default "__VITE_ASSET__BbHKWxFp__"